import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import api from "../../services/api";
import { formataDataHoraExibicao } from "../../common/utils";

const escapeHtml = (v) =>
  String(v ?? "").replace(
    /[&<>"']/g,
    (c) =>
      ({
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
      }[c])
  );

// Exclusao definitiva do reporte de farmacovigilancia, restrita a superadmin.
// Alem do aviso de irreversibilidade, exige digitar o ID do reporte para evitar
// excluir a linha errada. Retorna true quando a exclusao foi concluida.
export const excluirReporteFarmaco = async (reporte) => {
  const MySwal = withReactContent(Swal);
  const reporteId = reporte?.id;
  const prestador = reporte?.dados_prestador?.nome || "-";
  const atendimentoId = reporte?.dados_atendimento?.id || "-";
  const dataEnvio = reporte?.data_cadastro
    ? formataDataHoraExibicao(reporte.data_cadastro)
    : "-";
  const copiaId = reporte?.copia_de_trabalho_id;

  const result = await MySwal.fire({
    title: "Excluir reporte?",
    html: `
      <div style="text-align: left;">
        <p>Você está prestes a excluir o reporte <strong>#${escapeHtml(
          reporteId
        )}</strong>, enviado em <strong>${escapeHtml(
      dataEnvio
    )}</strong> por <strong>${escapeHtml(prestador)}</strong> (atendimento vinculado <strong>${escapeHtml(
      atendimentoId
    )}</strong>).</p>
        <p class="text-danger"><strong>Atenção:</strong> Esta ação não pode ser revertida. Serão excluídas também as respostas do formulário e as notificações geradas por este reporte. O atendimento vinculado é preservado.</p>
        ${
          copiaId
            ? `<p class="text-danger">Existe uma cópia de análise (#${escapeHtml(
                copiaId
              )}) deste reporte. Ela <strong>não</strong> será excluída e ficará sem o reporte de origem.</p>`
            : ""
        }
        <hr/>
        <div class="mb-2">
          <label for="swal-confirma-reporte-id" class="form-label">Para confirmar, digite o ID do reporte (<strong>${escapeHtml(
            reporteId
          )}</strong>):</label>
          <input id="swal-confirma-reporte-id" class="form-control" type="text" inputmode="numeric" autocomplete="off" placeholder="ID do reporte" />
        </div>
      </div>
    `,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Sim, excluir!",
    cancelButtonText: "Cancelar",
    focusConfirm: false,
    preConfirm: () => {
      const input = document.getElementById("swal-confirma-reporte-id");
      const valorDigitado = input ? input.value.trim() : "";
      if (valorDigitado !== String(reporteId)) {
        Swal.showValidationMessage(`Digite o ID ${reporteId} para confirmar.`);
        return false;
      }
      return true;
    },
  });

  if (!result.isConfirmed) return false;

  Swal.fire({
    title: "Excluindo reporte...",
    allowOutsideClick: false,
    didOpen: () => {
      Swal.showLoading();
    },
  });

  try {
    await api.delete(`/formularios/respostas/${reporteId}/`);
    await MySwal.fire(
      "Excluído!",
      "O reporte foi excluído com sucesso.",
      "success"
    );
    return true;
  } catch (error) {
    console.error("Erro ao excluir reporte:", error);
    let erro_msg = "Não foi possível excluir o reporte. Tente novamente.";
    if (error.response?.status === 403) {
      erro_msg = "Você não tem permissão para excluir reportes.";
    } else if (error.response?.status === 404) {
      erro_msg = "Reporte não encontrado. Ele pode já ter sido excluído.";
    }
    await MySwal.fire("Erro!", erro_msg, "error");
    return false;
  }
};
